export enum OtpMethods {
	EMAIL = "EMAIL",
	SMS = "SMS",
	ZNS = "ZNS",
}
